<ion-app handle-keyboard-events [class.public-app]="isPublicWebApp">
  @if (isPublicWebApp) {
    <formlos-header></formlos-header>
    <div class="public-scroll-region" #publicScrollRegion>
      <ion-router-outlet [class.public-home-outlet]="isHomeRoute"></ion-router-outlet>
      <formlos-footer></formlos-footer>
    </div>
  } @else {
    <ion-router-outlet></ion-router-outlet>
  }
  <app-matomo-consent></app-matomo-consent>
</ion-app>
